export default [
  "$PERSON $TRANSITIVEVERBSINGLE $PERSON",
  "$PEOPLE $TRANSITIVEVERBPLURAL $PEOPLE",
  "$PERSON $INTRANSITIVEVERB and $TRANSITIVEVERBSINGLE $PERSON",
  "we dock at $HARBOR where $HARBORDESCRIPTOR",
  "$PERSON $INTRANSITIVEVERB",
  "$PERSON has a bout of $ILLNESS",
  "a merchant arrives and tries to sell us $TRINKET",
  "we $TRAVELWORD $ENVIRONMENT past $LANDMARKNEARBY",
  "we $TRAVELWORD through $LANDMARKTHROUGH $ENVIRONMENT",
];
